import angular from 'angular';

class modalPerimeterDeleteCtrl {
    /* @ngInject */
    constructor(logger) {
        this.logger = logger;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }

    confirm() {
        this.modalInstance.close();
    }
}

angular.module('app.principal').component('modalPerimeterDelete', {
    templateUrl: require('./modal-delete-perimeter.html'),
    controller: modalPerimeterDeleteCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
